"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIErrorSupplier = void 0;
const APIError_1 = require("./APIError");
const APITemplateSupplier_1 = require("./APITemplateSupplier");
class APIErrorSupplier extends APITemplateSupplier_1.APITemplateSupplier {
    constructor() {
        super(...arguments);
        this.separator = " ";
    }
    get(mainDef, mainContent = [], subDef, subContent) {
        return new APIError_1.APIError(this, this.translationsSection, mainDef, mainContent, subDef, subContent);
    }
    getSeparator() {
        return this.separator;
    }
    setTranslations(translations) {
        super.setTranslations(translations);
        if (this.translations) {
            this.translationsSection = this.translations.errors;
            if (this.translationsSection) {
                this.separator = (this.translationsSection.separator);
            }
            if (!this.separator) {
                this.separator = "";
            }
        }
        else {
            this.translationsSection = undefined;
            this.separator = " ";
        }
    }
}
exports.APIErrorSupplier = APIErrorSupplier;
